export const TICK_RATE = 30;
/** El último héroe enemigo que dañó a otro en este plazo se lleva la kill aunque lo remate una torre o un minion. */
export const KILL_CREDIT_TICKS = 30 * TICK_RATE;
export const TICK_DT = 1 / TICK_RATE;

export const ARENA_RADIUS = 62;
export const HERO_RADIUS = 0.45;
export const RESPAWN_TICKS = 90;
export const SPAWN_PROTECTION_TICKS = 30;
/** Canalización del regreso a base (tecla B). */
export const RECALL_TICKS = 6 * TICK_RATE;

export const KNOCKBACK_FRICTION = 0.86;
export const KNOCKBACK_MIN_SPEED = 0.4;

export const CHAIN_WINDOW_TICKS = 14;
